module.exports = __webpack_public_path__ + "img/mingcaiBg.429b841d.jpg";